<template>
    <div>
        <div class="texts">
            <div class="bold">{{ item.name }}</div>
            <div class="description">SAP Ref: {{ item.clientSapRef }}</div>
            <div class="description">Client Ref: {{ item.clientRef1 }}</div>
        </div>
        <ItemImage :item="item" />
    </div>
</template>
<script>
import ItemImage from "@/components/forecasts/elements/ItemImage";
export default {
    components: { ItemImage },
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// CatalogueItemDescription.vue?127996ca